import { queryOptions, useQuery } from '@tanstack/react-query';

import { shippingApi } from '../api/shipping-api';

import { shippingKeys } from './shipping-keys';

export function shippingZonesQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: shippingKeys.zones(storeId),
    queryFn: () => shippingApi.listZones(storeId),
  });
}

export function useShippingZones(storeId: string) {
  return useQuery(shippingZonesQueryOptions(storeId));
}
